<template>
  <div
    class="video-modal"
  >
    <img
      :src="placeholder"
      class="video-modal__placeholder"
      :class="{
        'video-modal__placeholder--visible': !isModalVisible,
      }"
    >
    <button
      class="video-modal__play"
      :class="{
        'video-modal__play--visible': !isModalVisible,
      }"
      @click="onClickButton"
    >
      Play
    </button>

    <div
      v-if="isModalVisible"
      role="tooltip"
      class="video-modal__modal"
      :class="{'video-modal__modal--youtube' : isYoutube}"
    >
      <div
        v-if="isYoutube"
        class="video-modal__video video-modal__video--youtube"
      >
        <YouTubePlayer
          :id="youtubeVideoId"
          :auto-play="true"
        />
      </div>

      <video
        v-if="!isYoutube"
        ref="video"
        class="video-modal__video"
        :src="video"
        autoplay
      />
    </div>
  </div>
</template>

<script>
import YouTubePlayer from './youtube-player/youtube-player.vue';

export default {
  components: { YouTubePlayer },

  props: {
    video: {
      required: true,
      type: String,
    },

    placeholder: {
      required: true,
      type: String,
    },
  },

  data: () => ({
    isModalVisible: false,
  }),

  computed: {
    isYoutube() {
      const youtubeRegex = /^(https?:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/;
      return youtubeRegex.test(this.video);
    },

    youtubeVideoId() {
      if (!this.isYoutube) {
        return null;
      }

      try {
        const urlSearchParams = new URL(this.video).searchParams || {};
        const params = Object.fromEntries(urlSearchParams.entries());

        return params.v;
      } catch (e) {
        console.error('Unable to parse Youtube video ID from URL', {
          url: this.video,
        });

        return null;
      }
    },
  },

  methods: {
    onClickButton() {
      console.log('btn click');
      this.isModalVisible = true;
    },
  },
};
</script>
